import { callApi } from "@/api/api-core";

export const createMerchantSession = function() {
    console.log("calling create session")
 return callApi("POST", "v1/payment/applepay/session/create");
};
